import React from 'react';
import AuthLayout from './AuthLayout';
import { OnboardingLoginPage } from '../../components/Onboarding/Login';

function action(context) {
  const { query } = context;
  const isInternalUser = context.portalConfig.viewMode === 'internal';
  const isRefreshAction = query?.action === 'refresh';
  const isInternalLogin = isInternalUser && !isRefreshAction;
  const { title, description } =
    query?.step === 'forgotPassword'
      ? {
          title: 'Copilot • Forgot Password',
          description:
            'Recover your password to log back in to your Copilot account. ',
        }
      : {
          title: 'Copilot • Log in',
          description:
            'Log in to the Copilot Dashboard to manage your business.',
        };
  return {
    chunks: ['login'],
    ...(isInternalLogin ? { title, description } : {}),
    component:
      // internal users can access the /login page in 2 scenarios
      // 1. they are trying to login to a portal and should see the login form (OnboardingLoginPage)
      // 2. they tried to access a page that requires auth and were redirected to the login page because their cookie expired and they need to refresh their session. (AuthLayout)
      //   In this scenario, the query param 'action=refresh' is added to the url (see app.get('*) in server.js)
      //   the AuthLayout component redirects the user to the app after refreshing their session (in Authenticator.tsx:checkUser) and the IU is not shown the login form
      // client users are always redirected to the AuthLayout component when they access the /login page
      //   the AuthLayout component also handles the case where the client is not authenticated and shows the "Client login" screen
      //   without any copilot branding
      isInternalLogin ? <OnboardingLoginPage /> : <AuthLayout />,
  };
}

export default action;
